import axios from "axios";
import { Action, Mutation } from "../types";
import { Mutation as SessionMutation } from "@/store/session/types";
import { Mutation as ScheduleMutation } from '@/store/schedule/types';

export default {
  [Action.GET_DEVICE]({ commit, state }, hash) {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_API_URL + 'hubs/' + hash)
        .then((resp) => {
          commit(`${Mutation.GET_DEVICE}`, resp.data.data);
          commit(`${ScheduleMutation.SET_SCHEDULES}`, {
            result: resp.data.data.schedules,
            hash: hash,
          });
          resolve(resp, resp.data.data);
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 401) {
              commit(`${SessionMutation.LOGOUT}`);
            }
          }
          reject(err);
        });
    });
  },
  [Action.GET_DEVICES]({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_API_URL + "hubs")
        .then((resp) => {
          commit(`${Mutation.GET_DEVICES}`, resp.data.data);
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 401) {
              commit(`${SessionMutation.LOGOUT}`);
              window.location = process.env.VUE_APP_LOGIN_URL;
            }
          }
          reject(err);
        });
    });
  },
};
